module.exports = __webpack_public_path__ + "static/media/educators-03.aa5cd49b.jpg";